import {AfterViewChecked, Component, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {HttpParams} from '@angular/common/http';
import {DashboardService} from '../../Services/dashboard.service';
import {Grid} from '../../../shared/Models/grid';
import {TextColumn} from '../../../shared/Models/columns';
import {OrderService} from '../../Services/order.service';
import {Supplier} from '../../../back-office/Models/Supplier';
import {TranslateService} from '@ngx-translate/core';
import {Role} from '../../../shared/Models/Role';
import {AuthenticationService} from '../../../shared/Services/authentication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewChecked {
  public grid: Grid;
  public suppliers: Supplier[];
  public blocks: {
    id: number;
    title: string;
    content: string;
    locked;
  }[][] = [];
  @ViewChild('container', {static: false}) container;
  listenClickFunc: Function;

  constructor(
    private router: Router,
    private dashboardService: DashboardService,
    private renderer: Renderer2,
    private orderService: OrderService,
    private translator: TranslateService,
    private auth: AuthenticationService
  ) {
  }


  ngOnInit() {
    this.dashboardService.getSuppliers().subscribe(res => {
      this.suppliers = res['suppliers'];
    });
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.order.number',
          prop: 'orderNo',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.order.reference',
          prop: 'reference',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        }
      ],
      service: this.orderService,
      rememberURL: this.router.url,
      method: 'getDeliveryOrders',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
    };
    /**
     * Create blocks for columns ( Split data into 2 column )
     */
    this.dashboardService.getBlocks(new HttpParams(), 'dealer-system').subscribe((resp) => {
      this.blocks = [[], []];
      resp.data.forEach((v, i) => {
        this.blocks[(i % 2 == 0 ? 0 : 1)].push(v);
      });
      this.blocks.forEach(blockContainers => {
        blockContainers.forEach(block => {
          block.content = this.formatBlock(block.content);
        });
      });
    });
  }

  ngAfterViewChecked() {
    Array.from(this.container.nativeElement.querySelectorAll('a'))
      .filter((el: any) => !el.hasAttribute('ng-reflect-router-link'))
      .forEach((el: any) => {
        this.listenClickFunc = this.renderer.listen(el, 'click', (event) => {
          const url = el.getAttribute('href').toString();
          if (url.startsWith('/')) {
            event.preventDefault();
            this.router.navigate([el.getAttribute('href')]);
          }
        });
      });
  }

  formatBlock(content: string) {
    const matches = content.match(/{{deliveryWeek:[0-9]*}}/g);
    if (matches) {
      matches.forEach(supplierDeliveryWeek => {
        const dealerId = parseInt(supplierDeliveryWeek.match(/\d+/)[0]);
        const supplier = this.suppliers.find(dealer => dealer.id === dealerId);
        const weekString = this.translator.instant('global.' + (dealerId === 1 ? 'week' : 'weeks')).toLocaleLowerCase();
        content = content.replace(supplierDeliveryWeek, supplier.deliveryWeek + ' ' + weekString);
      });
    }
    return content;
  }
  isDisable() {
    return this.auth.getRole() !== Role.ROLE_BACK_OFFICE &&  this.auth.getStatus() === 'on_hold';
  }

}
